export default __webpack_public_path__ + "static/media/today-sales.832e3fd4.svg";